import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import { Visibility as VisionIcon } from '@mui/icons-material';

const VisionMission: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <VisionIcon sx={{ fontSize: 40 }} />
          Vision & Mission
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Our data strategy vision and mission statement
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 4, background: 'linear-gradient(135deg, #0055AA 0%, #0066CC 100%)', color: 'white' }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: 'white' }}>🎯 Our Vision</Typography>
            <Typography variant="body1" sx={{ mb: 3, color: 'white' }}>
              To establish a world-class data governance program that ensures data integrity, quality, and accessibility
              while enabling data-driven decision making and compliance with federal standards.
            </Typography>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: 'white' }}>🚀 Our Mission</Typography>
            <Typography variant="body1" sx={{ color: 'white' }}>
              Implement and maintain a comprehensive data governance framework aligned with DHS Data Governance Council Charter
              and Federal Data Strategy, fostering a culture of data stewardship, collaboration, and continuous improvement.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Core Principles
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              ✓ Data Integrity & Quality
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              ✓ Transparency & Accountability
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              ✓ Collaboration & Engagement
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              ✓ Compliance & Security
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ✓ Continuous Improvement
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Strategic Goals
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Achieve 95% data quality score
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → 100% policy compliance
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Full DHS alignment by Q2 2026
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              → Governance maturity level 4
            </Typography>
            <Typography variant="body2" color="text.secondary">
              → Enterprise-wide adoption
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Strategic Planning Tools Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Goal tracking, KPI dashboards, Strategic initiatives, Progress monitoring.
        </Typography>
      </Paper>
    </Container>
  );
};

export default VisionMission;
